import styled from '@emotion/styled';

export const Box = styled.div`
  min-width: 20rem;
  max-width: 20rem;
  height: 27.5rem;
  transition: 0.3s ease-in-out;
`;

export const BoxHeader = styled.div`
  height: 7.5rem;
`;
